import { render, staticRenderFns } from "./GHLConfig.vue?vue&type=template&id=d2241c8e&scoped=true"
import script from "./GHLConfig.vue?vue&type=script&lang=js"
export * from "./GHLConfig.vue?vue&type=script&lang=js"
import style0 from "./GHLConfig.vue?vue&type=style&index=0&id=d2241c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2241c8e",
  null
  
)

export default component.exports